enum ENivelUsuarioERP {
  // Indefinido = -1,
  Indefinido = 0,
  Supervisor = 1,
  Consultor = 2,
  Comissionado = 3,
  Cliente = 4,
  Preposto = 5,
}

export default ENivelUsuarioERP;

export const cDESCRICAO_AMIGAVEL_NIVEL_USUARIO: Record<ENivelUsuarioERP, string> = {
  //[ENivelUsuarioERP.Indefinido]: '-1 - Indefinido',
  [ENivelUsuarioERP.Indefinido]: '0 - Indefinido',
  [ENivelUsuarioERP.Supervisor]: '1 - Supervisor',
  [ENivelUsuarioERP.Consultor]: '2 - Consultor',
  [ENivelUsuarioERP.Comissionado]: '3 - Comissionado',
  [ENivelUsuarioERP.Cliente]: '4 - Cliente',
  [ENivelUsuarioERP.Preposto]: '5 - Preposto',
};

export const cNIVEIS_AMIGAVEIS_USUARIO: { texto: string; valor: ENivelUsuarioERP }[] = [
  { texto: cDESCRICAO_AMIGAVEL_NIVEL_USUARIO[ENivelUsuarioERP.Indefinido], valor: ENivelUsuarioERP.Indefinido },
  { texto: cDESCRICAO_AMIGAVEL_NIVEL_USUARIO[ENivelUsuarioERP.Supervisor], valor: ENivelUsuarioERP.Supervisor },
  { texto: cDESCRICAO_AMIGAVEL_NIVEL_USUARIO[ENivelUsuarioERP.Consultor], valor: ENivelUsuarioERP.Consultor },
];
